import React from 'react';

import Moment from 'react-moment';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import {ThirdPartyCard} from '../ThirdPartyCard';
import {Info} from '../Info';
import smartlookClient from 'smartlook-client';

import {HistoryDialog} from '../HistoryDialog';
import {AlfaMessageDialog} from '../AlfaMessageDialog';

import {Status} from '../Status';
import {BundleLink} from '../BundleLink';
import {QuoteLink} from '../QuoteLink';
import {ThirdPartyLink} from '../ThirdPartyLink';
import {CloseCaseDialog} from '../CloseCaseDialog';

import Alert from '@material-ui/lab/Alert';

import styles from './index.css';
import {DeereCachedFetch} from '../../shared/fetch';



export class QuoteDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            isError: '',
            isWarning:false
        }
    }



    async componentDidMount() {

        const alfaWarningMessages = await DeereCachedFetch('/api/alfamessages', {
            query: {
                bundleNumber: this.props.quote.bundleNumber
            }
        });
        if (this.props.quote.alfaMessage && this.props.quote.alfaMessage.messageType === 'ERROR') {
            this.setState({isError: 'ERROR'})
        } else {
            alfaWarningMessages.map(message => {
                // this.setState({isWarning: message.messageType})
                if (message.messageType === 'WARNING') {
                    this.setState({isWarning: true})
                }
            })
        }
    }

    render() {
        smartlookClient.record({ forms: true, numbers: true, emails: false });
        let message = '';
        if (this.props.quote.alfaMessage) {

            message = this.props.quote.alfaMessage.messageDetails + ' :: ' + this.props.quote.alfaMessage.messageSummary;
        } else {
            message = 'No message found';
        }
        return (
            <Grid className={styles.root} container direction="column" spacing={1}>
                <Typography style={{marginBottom: 10}} variant="h6">Quote Details</Typography>
                <Grid container item justify="space-between">
                    <Grid container item md={8} sm={6} spacing={1} xs={12}>
                        <Grid container direction="column" item md={6} sm={12} spacing={1}>
                            <Grid item>
                                <Info label="Bundle">
                                    <BundleLink bundleNumber={this.props.quote.bundleNumber}/>
                                </Info>
                            </Grid>
                            <Grid item>
                                <Info label="Quote">
                                    <QuoteLink quoteNumber={this.props.quote.quoteNumber}/>
                                </Info>
                            </Grid>
                            <Grid item>
                                <Info label="ICS ID">{this.props.quote.icsID || 'N/A'}</Info>
                            </Grid>
                            <Grid item>
                                <Info label="Message">
                                    <Status errorMessage={this.props.quote.errorMessage} includeID statusID={this.props.quote.statusID}/>
                                </Info>
                            </Grid>
                            <Grid item>
                                <Info label="Message Details">
                                    <AlfaMessageDialog bundleNumber={this.props.quote.bundleNumber} msg={message}/>
                                </Info>
                            </Grid>
                            <Grid item>
                                <Info label="Status Message">
                                    {this.state.isError==='ERROR' ? <Alert severity="error">Proposal Has Errors</Alert> :
                                        (this.state.isWarning ?<Alert severity="warning">Proposal Loaded with Warning</Alert>
                                            :<Alert severity="success">Proposal Loaded</Alert>
                                        )}
                                </Info>
                            </Grid>
                            <Grid item>
                                <Info label="Dealer Details">
                                    <ThirdPartyLink thirdPartyNumber={this.props.quote.alfaDealerIdentifier}/>

                                </Info>
                            </Grid>
                        </Grid>

                        <Grid container direction="column" item md={6} sm={12} spacing={1}>
                            <Grid item>
                                <Info label="Country">{this.props.quote.country} ({this.props.quote.countryCode})</Info>
                            </Grid>
                            <Grid item>
                                <Info label="Resubmitted">{this.props.quote.resubmitted ? 'Yes' : 'No'}</Info>
                            </Grid>
                            <Grid item>
                                <Info label="Created Date">
                                    {this.props.quote.createdDate ? (
                                        <Moment format="MMMM Do, YYYY">{this.props.quote.createdDate}</Moment>
                                    ) : 'N/A'}
                                </Info>
                            </Grid>
                            <Grid item>
                                <Info label="Updated Date">
                                    {this.props.quote.updatedDate ? (
                                        <Moment format="MMMM Do, YYYY">{this.props.quote.updatedDate}</Moment>
                                    ) : 'N/A'}
                                </Info>
                            </Grid>
                            <Grid item>
                                <Info label="ASM Name">
                                    {this.props.quote.asmName ? this.props.quote.asmName : '-'}
                                </Info>
                            </Grid>
                            <Grid item>
                                <Info label="SalesPerson Name">
                                    {this.props.quote.salesPersonName ? this.props.quote.salesPersonName : '-'}
                                </Info>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container direction="column" item md={6} sm={12} spacing={1}>
                    </Grid>
                    <Grid alignItems="flex-start" container item justify="flex-end" spacing={1} xs>
                        {this.props.quote.status === 'Open' && this.props.loggedInUser && (this.props.loggedInUser.role === 'ADMIN' || this.props.loggedInUser.role === 'ASSIGN') &&
                        <Grid item>
                            <CloseCaseDialog onclosecase={this.props.onChange} quote={this.props.quote}/>
                        </Grid>}
                        <Grid item>
                            <HistoryDialog quote={this.props.quote}/>
                        </Grid>
                    </Grid>

                </Grid>
                <Divider/>
                {this.props.thirdParties && (
                    <Grid container direction="column">
                        <Typography style={{margin: '10px 0'}} variant="h6">Third Parties</Typography>
                        <Grid container item spacing={1}>
                            {this.props.thirdParties.map((thirdParty) => (
                                <Grid item key={thirdParty.id} md={4} sm={6} xs={12}>
                                    <ThirdPartyCard quote={this.props.quote} thirdParty={thirdParty}/>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                )}
            </Grid>
        )
    }
}
